import React from "react";
import { Input } from "antd";

export const InputField = ({ value, label, onChange, error, placeholder, readOnly = false, ...args }: any) => {
    const inputClass = `w-full h-[48px] py-[13px] px-4 text-base leading-[22px] placeholder-[#94A3B8] placeholder:text-sm rounded-lg border ${
        readOnly ? 'bg-[#E5E7EB] cursor-not-allowed' : 'border-[#E2E8F0]'
    }`;
    return (
        <label
            className="flex flex-col items-center gap-2 w-full mb-[40px] text-sm leading-[19px] text-[#64748B] "
            htmlFor="email">
            <div className={`flex items-start justify-start w-full`}>
                <span>{label}</span>
            </div>
            <Input
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                readOnly={readOnly}
                className={inputClass}
            />
        </label>
    );
};
